import React, { FunctionComponent } from 'react';
import { object, number } from 'yup';
import { FormikHelpers, Formik, FormikProps, Field } from 'formik';
import { Grid, Button } from '@inplayer-org/inplayer-ui';

// utils
import isEmpty from 'lodash/isEmpty';

// Components
import { QuickAddData } from 'pages/MerchantPages/Assets/assetTypes';
import Input from 'components/Fields/Input';
import FieldError from 'components/Fields/FieldError';
import IntegrationMessage from '../IntegrationMessage';

const { Container, Cell } = Grid;

interface FormValues {
  eventId: string;
  videoId: string;
}

interface OwnProps {
  keys: any;
  onSubmit: (data: QuickAddData) => any;
  onBackButtonClick: () => void;
}

type Props = OwnProps;

const validationSchema = object().shape({
  eventId: number().required('*Required').integer('Value must be a number'),
  videoId: number().required('*Required').integer('Value must be a number'),
});

const LivestreamQuickAdd: FunctionComponent<Props> = ({ onSubmit, keys, onBackButtonClick }) => {
  const initialValues = {
    eventId: '',
    videoId: '',
  };

  const onFormSubmit = async (values: FormValues, { setSubmitting }: FormikHelpers<FormValues>) => {
    await onSubmit(values);
    setSubmitting(false);
  };

  const isIntegrated: boolean = keys && !isEmpty(keys);

  return isIntegrated ? (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        enableReinitialize
        onSubmit={onFormSubmit}
      >
        {({ handleSubmit, isSubmitting, isValid }: FormikProps<FormValues>) => (
          <form onSubmit={handleSubmit}>
            <Container columns={3} rowGap="2rem">
              <Cell width={3}>
                <Container columns={1}>
                  <Cell width={1}>
                    <Field
                      tag="text_input_livestream_event_id"
                      name="eventId"
                      type="text"
                      component={Input}
                      label="Event ID"
                    />
                    <FieldError name="eventId" />
                  </Cell>
                  <Cell width={1}>
                    <Field
                      tag="text_input_livestream_video_id"
                      name="videoId"
                      type="text"
                      component={Input}
                      label="Video ID"
                    />
                    <FieldError name="videoId" />
                  </Cell>
                </Container>
              </Cell>
              <Cell width={1}>
                <Button
                  tag="button_back"
                  fullWidth
                  buttonModifiers={['buttonLink']}
                  onClick={onBackButtonClick}
                  type="button"
                >
                  Back
                </Button>
              </Cell>
              <Cell width={1} left={3}>
                <Button
                  tag="button_save"
                  fullWidth
                  type="submit"
                  disabled={isSubmitting || !isValid}
                  buttonModifiers={['buttonPrimary']}
                >
                  Save
                </Button>
              </Cell>
            </Container>
          </form>
        )}
      </Formik>
    </>
  ) : (
    <IntegrationMessage ovpType="livestream" />
  );
};

export default LivestreamQuickAdd;
